import React, { Component } from 'react';

import fetch from '../services/fetch';
import fetchLocal from '../services/fetchLocal';
import logger from '../services/errorlogger';
import { message } from 'antd';

const StateContext = React.createContext();

class StateProvider extends Component {
    state = {
        user: {},
        userLoading: false, 
        userError: false,

        products: {},
        productsLoading: true,
        productsError: false,

        jobs: {},
        jobsLoading: true,
        jobsError: false,

        site: {},
        siteLoading: true,
        siteError: false,
        
        analytics: {},
        analyticsLoading: true,
        analyticsError: false,

        // selectedJobId: '-Mbp_xopHl4w1Erbq_D7',
        selectedJobId: null,

        apiKeyValid: true,
        validateApiKeyLoading: false, 
        validateApiKeyError: false,

        settings: {},
        settingsLoading: false,
        settingsError: false,
    }

    constructor(props) {
        super(props);
        
        if (this.props.wpObject) {
            this.fetchLocal = new fetchLocal({
                restURL: this.props.wpObject.api_url,
                restNonce: this.props.wpObject.api_nonce,
            });
        }
    }

    componentDidMount() {
        document.title = 'Plugin Demo | AMZ Watcher WP Plugin';
        this.fetch();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedJobId !== this.state.selectedJobId && this.state.selectedJobId) {
            this.fetchProductsLocal(this.state.selectedJobId);
        }
    }

    fetch = () => {
        this.fetchUserRemote();
        this.fetchSiteLocal();
        this.fetchAnalyticsLocal();
        this.fetchJobsLocal();
        this.fetchSettings();
        this.state.selectedJobId && this.fetchProductsLocal(this.state.selectedJobId);
    }

    refreshBackendData = async () => {
        try {
            this.setState({ refreshDataLoading: true, refreshDataError: false });

            const res = await this.fetchLocal.get(`refresh`);

            console.log('refreshBackendData local', res);
            
            this.setState({ refreshDataLoading: false, refreshDataError: false });
            this.fetch()
        } catch(e) {
            this.setState({ refreshDataLoading: false, refreshDataError: true });
            if (e.message.includes('API Key is not valid')) {
                this.setState({ apiKeyValid: false });
            }
            logger.logError(e);
            console.log(e);
        }
    }

    fetchUserRemote = async () => {
        try {
            this.setState({ userLoading: true, userError: false });

            const { apikey } = this.props;
            const res = await fetch.get(`plugin/user`, { headers: { apikey }});
            const user = res.data;
            console.log('user remote', user);
            this.setState({ user, userLoading: false, userError: false, apiKeyValid: true });
        } catch(e) {
            this.setState({ userLoading: false, userError: true });
            if (e.message.includes('API Key is not valid')) {
                console.log(e);
                return this.setState({ apiKeyValid: false });
            }
            logger.logError(e);
        }
    }

    fetchUserLocal = async () => {
        try {
            this.setState({ userLoading: true, userError: false });

            const res = await this.fetchLocal.get(`user`);
            const user = res.value;
            console.log('user local', user);
            this.setState({ user, userLoading: false, userError: false, apiKeyValid: true });
        } catch(e) {
            this.setState({ userLoading: false, userError: true });
            if (e.message.includes('API Key is not valid')) {
                this.setState({ apiKeyValid: false });
            }
            logger.logError(e);
            console.log(e);
        }
    }

    fetchSiteRemote = async () => {
        try {
            this.setState({ siteLoading: true, siteError: false });

            const { apikey } = this.props;
            const res = await fetch.get(`plugin/site`, { headers: { apikey }});
            const site = res.data;
            console.log('site remote', site);
            this.setState({ site, siteLoading: false, siteError: false });
        } catch(e) {
            this.setState({ siteError: true, siteLoading: false, });
            logger.logError(e);
            console.log(e);
        }
    }

    fetchSiteLocal = async () => {
        try {
            this.setState({ siteLoading: true, siteError: false });

            const res = await this.fetchLocal.get(`site`);
            let site = {};

            if (res.value && res.value !== 'Error') {
                site = JSON.parse(res.value.all_other);
            }
            console.log('site local', site);
            this.setState({ site, siteLoading: false, siteError: false });
        } catch(e) {
            this.setState({ siteError: true, siteLoading: false, });
            logger.logError(e);
            console.log(e);
        }
    }

    fetchJobsRemote = async () => {
        try {
            this.setState({ jobsLoading: true, jobsError: false });

            const { apikey } = this.props;
            const res = await fetch.get(`plugin/jobs/all/`, { headers: { apikey }});
            const jobs = res.data;
            console.log('jobs remote', jobs);
            this.setState({ jobs, jobsLoading: false, jobsError: false });
        } catch(e) {
            this.setState({ jobsError: true, jobsLoading: false, });
            logger.logError(e);
            console.log(e);
        }
    }

    fetchJobsLocal = async () => {
        try {
            this.setState({ jobsLoading: true, jobsError: false });

            const res = await this.fetchLocal.get(`jobs`);
            let jobs = {};

            if (res.value && res.value !== 'Error') {
                res.value.forEach(j => {
                    const job = JSON.parse(j.all_other);
                    jobs[j.crawlJobId] = { ...job, jobId: j.crawlJobId };
                });
            }
            
            console.log('jobs local', jobs);
            this.setState({ jobs, jobsLoading: false, jobsError: false });
        } catch(e) {
            this.setState({ jobsError: true, jobsLoading: false, });
            logger.logError(e);
            console.log(e);
        }
    }

    fetchProductsRemote = async (jobId) => {
        try {
            this.setState({ productsLoading: true, productsError: false });

            const { apikey } = this.props;
            const { products } = this.state;

            const res = await fetch.get(`plugin/products/${jobId}`, { headers: { apikey }});
            const fetchedProducts = res.data;
            console.log('fetchedProducts', fetchedProducts);

            const mappedProducts = Object.keys(fetchedProducts).map(productId => ({ productId, ...fetchedProducts[productId] }));
            const nextProducts = { ...products, [jobId]: mappedProducts };

            this.setState({ products: nextProducts, productsLoading: false, productsError: false });
        } catch(e) {
            this.setState({ productsError: true, productsLoading: false, });
            logger.logError(e);
            console.log(e);
        }
    }

    fetchProductsLocal = async (jobId) => {
        try {
            this.setState({ productsLoading: true, productsError: false });

            const { products } = this.state;

            const res = await this.fetchLocal.get(`products/${jobId}`);
            // debugger;
            let fetchedProducts = [];
            if (res.value && res.value !== 'Error' && Object.keys(res.value).length) {
                fetchedProducts = JSON.parse(res.value);
            }
            console.log('fetchedProducts', fetchedProducts);

            const mappedProducts = Object.keys(fetchedProducts).map(productId => ({ productId, ...fetchedProducts[productId] }));
            const nextProducts = { ...products, [jobId]: mappedProducts };

            this.setState({ products: nextProducts, productsLoading: false, productsError: false });
        } catch(e) {
            this.setState({ productsError: true, productsLoading: false, });
            logger.logError(e);
            console.log(e);
        }
    }

    fetchAnalyticsRemote = async () => {
        try {
            this.setState({ analyticsLoading: true, analyticsError: false });
            const { apikey } = this.props;
            const res = await fetch.get(`plugin/a`, { headers: { apikey }});
            const analytics = res.data;
            console.log('analytics remote', analytics);
            this.setState({ analytics, analyticsLoading: false, analyticsError: false });
        } catch(e) {
            this.setState({ siteError: true, analyticsLoading: false, });
            logger.logError(e);
            console.log(e);
        }
    }

    fetchAnalyticsLocal = async () => {
        try {
            this.setState({ analyticsLoading: true, analyticsError: false });

            const res = await this.fetchLocal.get(`analytics`);
            let analytics = {};

            if (res.value && res.value !== 'Error') {
                res.value.forEach(v => {
                    const parsedJobAnalytics = JSON.parse(v.all_other);
                    analytics[parsedJobAnalytics.jobId] = parsedJobAnalytics
                });
            }

            console.log('analytics local', analytics);
            this.setState({ analytics, analyticsLoading: false, analyticsError: false });
        } catch(e) {
            this.setState({ siteError: true, analyticsLoading: false, });
            logger.logError(e);
            console.log(e);
        }
    }

    resetApiKey = async () => {
        try {
            this.setState({ resetApiKeyLoading: true, resetApiKeyError: false });
            // this resets the API key
            const res = await this.fetchLocal.delete(`api-key`);

            this.setState({ resetApiKeyLoading: false, resetApiKeyError: false });
            window.location.reload();
        } catch(e) {
            this.setState({ resetApiKeyLoading: false, resetApiKeyError: true, });
            logger.logError(e);
            console.log(e);
        }
    }

    saveApiKey = async apiKey => {
        try {
            if (!apiKey || apiKey.length !== 36) {
                return message.warning({
                    content: 'Please provide a valid API Key', 
                    style: {
                        marginTop: '10vh',
                    },
                });
            }
            // debugger;
            this.setState({ saveApiKeyLoading: true, saveApiKeyError: false });
            
            const res = await this.fetchLocal.post(`api-key`, { api_key: apiKey });

            this.setState({ saveApiKeyLoading: false, saveApiKeyError: false });
            window.location.reload();
        } catch(e) {
            this.setState({ saveApiKeyLoading: false, saveApiKeyError: true, });
            logger.logError(e);
            console.log(e);
        }
    }

    fetchSettings = async () => {
        try {
            this.setState({ settingsLoading: true, settingsError: false });
            
            const res = await this.fetchLocal.get(`settings`);

            this.setState({ settingsLoading: false, settingsError: false, settings: res.value });
        } catch(e) {
            this.setState({ settingsLoading: false, settingsError: true, });
            logger.logError(e);
            console.log(e);
        }
    }

    saveSettings = async props => {
        try {
            this.setState({ toggleWidgetLoading: true, toggleWidgetError: false });
            
            const res = await this.fetchLocal.post(`settings`, props);

            message.success({ content: 'Saved!', style: { marginTop: '10vh' } });

            this.setState({ toggleWidgetLoading: false, toggleWidgetError: false });
        } catch(e) {
            this.setState({ toggleWidgetLoading: false, toggleWidgetError: true, });
            logger.logError(e);
            console.log(e);
        }
    }

    setSelectedJobId = jobId => {
        this.setState({ selectedJobId: jobId });
    }

    render() {
        const { state, refreshBackendData, setSelectedJobId } = this;
        const { apikey, failedFetchBackend } = this.props;

        const value = { 
            state, 
            apiKey: apikey, 
            failedFetch: failedFetchBackend, // this is failed fetch which is passed from the top component
            fetch: refreshBackendData, 
            setSelectedJobId, 
            resetApiKey: this.resetApiKey,
            saveApiKey: this.saveApiKey,
            saveSettings: this.saveSettings,
        };
        return <StateContext.Provider value={value}>{this.props.children}</StateContext.Provider>
    }
}

function useState() {
    const context = React.useContext(StateContext);
  
    if (context === undefined) {
        throw new Error('useState must be used within a CountProvider');
    }
  
    return context;
}


export { StateProvider, useState };